/**
 * The one cell on the board that is allowed to be fun.
 *
 * A job whose label mentions a birthday gets the whole cell: cake, confetti, a slow sweep of
 * colour. Everything else on this board is deliberately quiet — it is read at 6am by somebody
 * filling forty cells before the crews leave — and the exception is the point. A board that
 * has never once been cheerful is a board nobody looks forward to opening.
 *
 * Three rules keep it from becoming a nuisance:
 *
 *   It is a SUBSTRING match, case-insensitive, because nobody types a keyword. They type
 *   "MY BIRTHDAY !!" or "Sam's birthday — bring cake", and both should land.
 *
 *   It takes over only while nothing is being done to the cell. Hover it and the theme is
 *   gone, because the moment somebody reaches for a cell they are working, and a scheduler
 *   who cannot read the job under the confetti has been sold a joke at the cost of the tool.
 *
 *   The cell keeps everything else it holds. A birthday does not hide the day's real work —
 *   the other jobs sit under it in smaller type, still there, still clickable.
 */
export const isBirthday = (label) => typeof label === 'string' && /birthday/i.test(label)
